// extracted by mini-css-extract-plugin
var _1 = "CustomizeSidebar_summaryDetails__s3f6f";
export { _1 as "summaryDetails" }
